import { useTranslation } from "react-i18next";
import Authorize from "../../common/Authorize/Authorize";
import styles from "./DeletePopup.module.css";
import { Button, Form } from "react-bootstrap";

interface IDeletePopup {
    userId: number | undefined;
    shouldBeDeleted(arg0: boolean): void;
}

const DeletePopup: React.FC<IDeletePopup> = (props) => {
    const { t } = useTranslation();

    return (
        <Authorize
            strict={true}
            userId={props.userId}
            code={
                <div>
                    <div className={styles.background} />
                    <div className={styles.modal}>
                        <div className={styles.header}>
                            <h5>{t("components.feature.deletePopup.title")}</h5>
                        </div>
                        <div className={styles.content}>{t("components.feature.deletePopup.confirmDeletion")}</div>
                        <div className={styles.actions}>
                            <div className={styles.buttonsContainer}>
                                <Button
                                    variant="dark"
                                    className={styles.buttonLeft}
                                    onClick={() => props.shouldBeDeleted(false)}
                                >
                                    {t("common.no")}
                                </Button>
                                <Button
                                    variant="dark"
                                    className={styles.buttonRight}
                                    onClick={() => props.shouldBeDeleted(true)}
                                >
                                    {t("common.yes")}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            }
        />
    );
};

export default DeletePopup;
